import auth from '../utils/auth'

export const canUseTours = () => Boolean(auth.isMasterOrAdmin())

export const syncTourAccessBodyClass = () => {
    try {
        if (canUseTours()) {
            document.body.classList.add('hdv-tours-allowed')
        } else {
            document.body.classList.remove('hdv-tours-allowed')
        }
    } catch (error) {}
}

export const disablePopoverButtons = ({ next = false, prev = false } = {}) => {
    const nextButton = document.querySelector('.driver-popover-next-btn')
    const prevButton = document.querySelector('.driver-popover-prev-btn')

    if (nextButton && next) {
        nextButton.disabled = true
        nextButton.style.pointerEvents = 'none'
        nextButton.style.opacity = '0.55'
        nextButton.setAttribute('aria-disabled', 'true')
    }

    if (prevButton && prev) {
        prevButton.disabled = true
        prevButton.style.pointerEvents = 'none'
        prevButton.style.opacity = '0.55'
        prevButton.setAttribute('aria-disabled', 'true')
    }
}

export const HELP_ICON_HTML =
    '<span class="hdv-tour-help-icon-inline" aria-hidden="true">' +
    '<svg viewBox="0 0 24 24" width="20" height="20" focusable="false">' +
    '<circle cx="12" cy="12" r="9.25" fill="none" stroke="currentColor" stroke-width="1.75"/>' +
    '<path fill="currentColor" d="M9.6 9.2c.2-1.35 1.2-2.35 2.7-2.35 1.55 0 2.65.95 2.65 2.35 0 1.05-.55 1.7-1.45 2.25-.85.5-1.15.85-1.15 1.55v.45h-1.55v-.55c0-1.15.45-1.75 1.4-2.3.75-.45 1.05-.8 1.05-1.4 0-.7-.5-1.15-1.25-1.15-.75 0-1.25.45-1.4 1.2l-1.6-.25zm2.05 7.05c-.6 0-1.05-.45-1.05-1.05s.45-1.05 1.05-1.05 1.05.45 1.05 1.05-.45 1.05-1.05 1.05z"/>' +
    '</svg></span>'

export const bindFinishTourOnClick = (element, tourManager, tourName) => {
    if (!element || element._hdvTourFinishClick) return

    const onClick = () => {
        tourManager.finish(tourName)
    }

    element.addEventListener('click', onClick)
    element._hdvTourFinishClick = onClick
}

export const unbindFinishTourOnClick = (element) => {
    if (!element?._hdvTourFinishClick) return

    element.removeEventListener('click', element._hdvTourFinishClick)
    delete element._hdvTourFinishClick
}

export const bindStartTourLink = (
    tourManager,
    fromTourName,
    toTourName,
    waitSelector,
    options = {}) => {
    setTimeout(() => {
        const startTourLink = document.querySelector(`.driver-popover-description [data-hdv-start-tour="${toTourName}"]`)

        if (!startTourLink || startTourLink._hdvTourStartBound) return

        startTourLink._hdvTourStartBound = true
        startTourLink.addEventListener('click', (event) => {
            event.preventDefault()
            event.stopPropagation()
            if (!canUseTours()) return
            tourManager.handoff(fromTourName, toTourName, waitSelector, options)
        })
    }, 0)
}

export const bindElementHandoffClick = (element, tourManager, fromTour, toTour, waitSelector) => {
    if (!element || element._hdvTourHandoffClick) return

    const onClick = (event) => {
        event.preventDefault()
        event.stopPropagation()
        if (!canUseTours()) return
        tourManager.handoff(fromTour, toTour, waitSelector)
    }

    element.addEventListener('click', onClick)
    element._hdvTourHandoffClick = onClick
}

export const unbindElementHandoffClick = (element) => {
    if (!element?._hdvTourHandoffClick) return

    element.removeEventListener('click', element._hdvTourHandoffClick)
    delete element._hdvTourHandoffClick
}
